import { CalendarContainer } from "react-datepicker";

import "modules/WarrantyDashboard/components/WarrantyDashboardFilters/components/DatePickerContainer/DatePickerContainer.scss";

import type { ReactNode } from "react";

export const DatePickerContainer = ({ className, children }: { className: string; children: ReactNode }) => (
  <div className="DatePickerContainer">
    <CalendarContainer className={className}>{children}</CalendarContainer>
  </div>
);
